import { useAPI, useAsyncHandler } from '~/hooks/common';

import { API_ENDPOINT } from '~/constants';

import type { TypePostReturnOrdersParams } from '~/types/claim.types';
import type { TypeErrorResponseData } from '~/types/common.types';

/**
 * [반품 신청/등록] 반품 신청 등록 api 요청 훅
 */
const usePostReturnOrders = () => {
  const { runAsync } = useAsyncHandler();

  const postReturnOrders = useAPI<TypePostReturnOrdersParams>({
    endpoint: API_ENDPOINT.CLAIM.POST_RETURN_ORDERS,
    method: 'post',
  });

  const registerReturnOrders = async (
    {
      params,
      pathParams: { outboundOrderCode },
    }: {
      params: TypePostReturnOrdersParams;
      pathParams: { outboundOrderCode: string };
    },
    {
      onSuccess,
      onError,
    }: {
      onSuccess?: () => void;
      onError?: (error: TypeErrorResponseData['error']) => void;
    }
  ) => {
    runAsync(() => postReturnOrders({ params, pathParams: `?outboundOrderCode=${outboundOrderCode}` }), {
      onSuccess: onSuccess,
      onError: (error: TypeErrorResponseData['error']) => onError?.(error),
    });
  };

  return { registerReturnOrders };
};

export default usePostReturnOrders;
